import type { ReviewableOrder } from '@src/orders/domain/ReviewableOrder';
import { GET_ORDER_QUERY_KEY } from '@src/orders/hooks/useOrder';
import { GET_ORDER_LISTING_QUERY_KEY } from '@src/orders/hooks/useOrderListing';
import {
  useRefreshInvoice,
  useUpdateReviewableOrder,
} from '@src/orders/hooks/useReviewableOrder';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useRefreshOrder = ({ id }: { id: string }) => {
  const queryClient = useQueryClient();
  const { refreshInvoice } = useRefreshInvoice({ orderId: id });
  const { updateReviewableOrder } = useUpdateReviewableOrder();

  const refreshOrder = useCallback(
    (updatedOrder?: ReviewableOrder) => {
      void queryClient.resetQueries({ queryKey: [...GET_ORDER_QUERY_KEY, id] });
      void queryClient.resetQueries({
        queryKey: [...GET_ORDER_LISTING_QUERY_KEY, id],
      });

      if (updatedOrder) {
        updateReviewableOrder({ updatedOrder });
      } else {
        refreshInvoice();
      }
    },
    [id, queryClient, refreshInvoice, updateReviewableOrder],
  );

  return { refreshOrder };
};
